import { render, staticRenderFns } from "./GrowerDependantsTab.vue?vue&type=template&id=987e6724&scoped=true&"
import script from "./GrowerDependantsTab.vue?vue&type=script&lang=js&"
export * from "./GrowerDependantsTab.vue?vue&type=script&lang=js&"
import style0 from "./GrowerDependantsTab.vue?vue&type=style&index=0&id=987e6724&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987e6724",
  null
  
)

export default component.exports